<template>
  <div id="app" :class="{'no-nav': noNav}">
    <nav-bar class="navbar"></nav-bar>
    <div class="content-wrapper">
      <router-view class="content"></router-view>
    </div>
    <coupon-popup
      :visible="couponPopupVisible"
      :unUsedCouponList="unUsedCouponList"
      @hideDialog="couponPopupVisible = false"
    ></coupon-popup>
  </div>
</template>

<script>
import NavBar from '@/components/common/NavBar'
import CouponPopup from '@/components/common/CouponPopup'

export default {
  name: 'app',
  components: {
    NavBar,
    CouponPopup,
  },
  data() {
    return {
      couponPopupVisible: false,
    }
  },
  computed: {
    noNav() {
      return this.$route.meta.nav === false || (window.bridge && window.bridge.appInfo)
    },
    unUsedCouponList() {
      return this.$store.state.couponList.UN_USE || []
    },
  },
  watch: {
    unUsedCouponList: function(newVal, oldVal) {
      const timeStamp = this.moment().format('YYYYMMDD')
      if (localStorage.getItem('couponPopupDate') !== timeStamp && !window.bridge) {
        this.couponPopupVisible = !!newVal.length
      }
    },
    '$route': function(newVal, oldVal) {
      let zenDesk = document.getElementById('launcher')
      if (zenDesk) {
        zenDesk.style.display = newVal && newVal.name === 'Home' ? 'block' : 'none'
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@font-face {
  font-family: 'Reducto';
  src: url('./assets/fonts/Reducto-Condensed-SSi-Condensed.ttf');
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
}

.content {
  position: absolute;
  top: 64px;
  bottom: 0;
  width: 100%;
}

.no-nav {
  .navbar {
    display: none;
  }
  .content {
    top: 0;
    margin-top: 0;
  }
}
</style>
